var React = require('react');

function Change (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.5 30.023a1.5 1.5 0 011.5-1.5h25.5a1.5 1.5 0 010 3H21a1.5 1.5 0 01-1.5-1.5z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M39.425 23.136a1.5 1.5 0 012.121-.029l6 5.841a1.5 1.5 0 010 2.15l-6 5.841a1.5 1.5 0 11-2.092-2.15l4.896-4.766-4.896-4.766a1.5 1.5 0 01-.029-2.121zM0 18.341a1.5 1.5 0 011.5-1.5H27a1.5 1.5 0 110 3H1.5a1.5 1.5 0 01-1.5-1.5z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.575 11.454a1.5 1.5 0 01-.029 2.12L3.65 18.342l4.896 4.766a1.5 1.5 0 01-2.092 2.15l-6-5.841a1.5 1.5 0 010-2.15l6-5.84a1.5 1.5 0 012.12.028z","key":2})]);
}

Change.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Change;

Change.default = Change;
